module.exports = __webpack_public_path__ + "img/fullinfo.0aa438cf.svg";